
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const ContactSection = () => {
  return (
    <section className="py-16 md:py-24 bg-dental-cream">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="animate-fade-in-up">
            <span className="inline-block text-dental-highlight font-medium mb-4 uppercase tracking-wider text-sm">
              Get In Touch
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold mb-6 leading-tight">
              We're Here For You
            </h2>
            <p className="text-dental-muted mb-8">
              Have questions or ready to schedule your visit? Reach out to our friendly team today. We'll be happy to help you with any inquiries or to set up your next appointment.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="p-6 bg-white rounded-xl shadow-soft">
                <h3 className="text-lg font-medium mb-3">Contact Information</h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-3 text-dental-highlight mt-1"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    <div>
                      <p className="font-medium">Phone</p>
                      <a onClick={(e) => { e.preventDefault(); (window as any).gtag_report_conversion && (window as any).gtag_report_conversion("tel:+918010224989"); }} href="tel:+918010224989" className="text-dental-muted hover:text-dental-highlight transition-colors">+91 8010224989</a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-3 text-dental-highlight mt-1"><path d="M22 18.38V5.62a2 2 0 0 0-2.12-2h-15.76a2 2 0 0 0-2.12 2v12.76a2 2 0 0 0 2.12 2h15.76a2 2 0 0 0 2.12-2z"></path><path d="m2 5.62 10 8.38 10-8.38"></path></svg>
                    <div>
                      <p className="font-medium">Email</p>
                      <a href="mailto:asranisbdental@gmail.com" className="text-dental-muted hover:text-dental-highlight transition-colors">asranisbdental@gmail.com</a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-3 text-dental-highlight mt-1"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    <div>
                      <p className="font-medium">Address</p>
                      <p className="text-dental-muted">2nd Floor, Guman Building<br />Sadar, Nagpur, Maharashtra 440001</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="p-6 bg-white rounded-xl shadow-soft">
                <h3 className="text-lg font-medium mb-3">Office Hours</h3>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-dental-muted">Monday - Friday:</span>
                    <div className="text-right">
                      <div className="font-medium">10:00 AM - 3:00 PM</div>
                      <div className="font-medium">6:00 PM - 9:00 PM</div>
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-dental-muted">Saturday:</span>
                    <div className="text-right">
                      <div className="font-medium">10:00 AM - 3:00 PM</div>
                      <div className="font-medium">6:00 PM - 9:00 PM</div>
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-dental-muted">Sunday:</span>
                    <div className="text-right">
                      <div className="font-medium">11:00 AM - 2:00 PM</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <Button className="btn-primary flex items-center text-base group" asChild>
              <Link to="/contact">
                Contact Us
                <ArrowRight size={18} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
          
          <div className="relative animate-fade-in">
            <div className="aspect-square relative rounded-xl overflow-hidden shadow-soft">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.170271266254!2d79.08215611473774!3d21.14716078594136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c0bfaaaaaaab%3A0x24cdd9b757bc4f0c!2sAsrani%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1722178057284!5m2!1sen!2sin!4v1722178057284!5m2!1sen!2sin" 
                width="100%" 
                height="100%" 
                style={{
                  border: 0
                }} 
                allowFullScreen={true} 
                loading="lazy" 
                title="Dental clinic location"
              ></iframe>
              
              <div className="absolute bottom-4 left-4 right-4 bg-white p-4 rounded-lg shadow-soft">
                <h3 className="font-medium text-dental-text mb-1">Asrani Dental Clinic</h3>
                <p className="text-sm text-dental-muted">2nd Floor, Guman Building, Sadar</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
